module.exports = "/static/assets/71e18caa5aa8dbdbf4c9964298d4a0fd.png";